import React from "react"
import { BrowserRouter } from "react-router-dom"

import AppRoutes from "./routes/AppRoutes"
import WhatsAppButton from "./components/contact/WhatsAppButton"

import "./styles/global.css"

export default function App() {
  return (
    <BrowserRouter>
      {/* App Routes */}
      <AppRoutes />

      {/* Floating WhatsApp (global CTA) */}
      <WhatsAppButton />
    </BrowserRouter>
  )
}